/*
 * Creates query params
 * @param query {Object}
 * @return {String} query
 * e.g:
 * query = { name: 'username', age: '18' }
 * queryParams 'name=username&age=18'
 */
export function createQueryParams(query) {
  if (!query || Object.keys(query).length < 1) {
    return
  }

  const esc = encodeURIComponent

  const queryParams = Object.keys(query)
    .map((k) => `${esc(k)}=${esc(query[k])}`)
    .join('&')

  return queryParams
}
